"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _ChannelProvider_connections, _ChannelProvider_protectedObj, _ChannelProvider_strategy, _ChannelProvider_removeEndpoint, _ChannelProvider_close;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChannelProvider = void 0;
const channel_1 = require("./channel");
const runtimeVersioning_1 = require("../../../util/runtimeVersioning");
class ChannelProvider extends channel_1.ChannelBase {
    get connections() {
        return [...__classPrivateFieldGet(this, _ChannelProvider_connections, "f")];
    }
    static handleClientDisconnection(channel, payload) {
        const removeById = channel.connections.find((identity) => identity.endpointId === payload.endpointId);
        if (removeById) {
            __classPrivateFieldGet(channel, _ChannelProvider_removeEndpoint, "f").call(channel, removeById);
        }
        else {
            const multipleRemoves = channel.connections.filter((identity) => {
                return identity.uuid === payload.uuid && identity.name === payload.name;
            });
            multipleRemoves.forEach(__classPrivateFieldGet(channel, _ChannelProvider_removeEndpoint, "f"));
        }
        channel.disconnectListener(payload);
    }
    static setProviderRemoval(provider, remove) {
        ChannelProvider.removalMap.set(provider, remove);
    }
    constructor(providerIdentity, wire, strategy) {
        super();
        _ChannelProvider_connections.set(this, void 0);
        _ChannelProvider_protectedObj.set(this, void 0);
        _ChannelProvider_strategy.set(this, void 0);
        _ChannelProvider_removeEndpoint.set(this, (identity) => {
            const remainingConnections = this.connections.filter((clientIdentity) => clientIdentity.endpointId !== identity.endpointId);
            __classPrivateFieldGet(this, _ChannelProvider_strategy, "f").closeEndpoint(identity.endpointId);
            __classPrivateFieldSet(this, _ChannelProvider_connections, remainingConnections, "f");
        });
        // Must be bound.
        this.processAction = async (action, payload, senderIdentity) => {
            if (ChannelProvider.clientIsMultiRuntime(senderIdentity) &&
                !(0, runtimeVersioning_1.runtimeUuidMeetsMinimumRuntimeVersion)(senderIdentity.runtimeUuid, '18.87.56.0')) {
                this.handleMultiRuntimeLegacyClient(senderIdentity);
            }
            else {
                this.checkForClientConnection(senderIdentity);
            }
            return super.processAction(action, payload, senderIdentity);
        };
        _ChannelProvider_close.set(this, () => {
            __classPrivateFieldGet(this, _ChannelProvider_strategy, "f").close();
            const remove = ChannelProvider.removalMap.get(this);
            if (remove) {
                remove();
            }
        });
        __classPrivateFieldSet(this, _ChannelProvider_protectedObj, new channel_1.ProtectedItems(providerIdentity, wire), "f");
        this.connectListener = () => undefined;
        this.disconnectListener = () => undefined;
        __classPrivateFieldSet(this, _ChannelProvider_connections, [], "f");
        __classPrivateFieldSet(this, _ChannelProvider_strategy, strategy, "f");
        strategy.receive(this.processAction);
    }
    dispatch(to, action, payload) {
        var _a;
        const endpointId = (_a = to.endpointId) !== null && _a !== void 0 ? _a : this.getEndpointIdForOpenFinId(to, action);
        if (endpointId && __classPrivateFieldGet(this, _ChannelProvider_strategy, "f").isEndpointConnected(endpointId)) {
            return __classPrivateFieldGet(this, _ChannelProvider_strategy, "f").send(endpointId, action, payload);
        }
        return Promise.reject(new Error(`Client connection with identity uuid: ${to.uuid} / name: ${to.name} / endpointId: ${endpointId} no longer connected.`));
    }
    async processConnection(senderId, payload) {
        __classPrivateFieldGet(this, _ChannelProvider_connections, "f").push(senderId);
        return this.connectListener(senderId, payload);
    }
    publish(action, payload) {
        return this.connections.map((to) => __classPrivateFieldGet(this, _ChannelProvider_strategy, "f").send(to.endpointId, action, payload));
    }
    onConnection(listener) {
        this.connectListener = listener;
    }
    onDisconnection(listener) {
        this.disconnectListener = listener;
    }
    async destroy() {
        const protectedObj = __classPrivateFieldGet(this, _ChannelProvider_protectedObj, "f");
        const { channelName } = protectedObj.providerIdentity;
        __classPrivateFieldSet(this, _ChannelProvider_connections, [], "f");
        await protectedObj.wire.sendAction('destroy-channel', { channelName });
        __classPrivateFieldGet(this, _ChannelProvider_close, "f").call(this);
    }
    async getAllClientInfo() {
        return this.connections.map((clientInfo) => {
            const { uuid, name, endpointId, entityType, connectionUrl } = clientInfo;
            return { uuid, name, endpointId, entityType, connectionUrl };
        });
    }
    checkForClientConnection(clientIdentity) {
        if (!this.isClientConnected(clientIdentity)) {
            throw new Error(`This action was sent from a client that is not connected to the provider.
                    Client Identity: {uuid: ${clientIdentity.uuid}, name: ${clientIdentity.name}, endpointId: ${clientIdentity.endpointId}}`);
        }
    }
    isClientConnected(clientIdentity) {
        if (ChannelProvider.clientIdentityIncludesEndpointId(clientIdentity)) {
            return this.connections.some((identity) => {
                return (
                // Might be redundant to check for uuid and name here after we get an endpointId match, but just in case
                identity.endpointId === clientIdentity.endpointId &&
                    identity.uuid === clientIdentity.uuid &&
                    identity.name === clientIdentity.name);
            });
        }
        return this.isLegacyClientConnected(clientIdentity);
    }
    isLegacyClientConnected(clientIdentity) {
        return this.connections.some((identity) => {
            return identity.uuid === clientIdentity.uuid && identity.name === clientIdentity.name;
        });
    }
    handleMultiRuntimeLegacyClient(senderIdentity) {
        if (!this.isLegacyClientConnected(senderIdentity)) {
            throw new Error(`This action was sent from a client that is not connected to the provider. Client Identity:
                    {uuid: ${senderIdentity.uuid}, name: ${senderIdentity.name}, endpointId: ${senderIdentity.endpointId}}`);
        }
    }
    getEndpointIdForOpenFinId(clientIdentity, action) {
        var _a;
        const matchingConnections = this.connections.filter((c) => c.name === clientIdentity.name && c.uuid === clientIdentity.uuid);
        if (matchingConnections.length >= 2) {
            const protectedObj = __classPrivateFieldGet(this, _ChannelProvider_protectedObj, "f");
            const { uuid, name } = clientIdentity;
            const providerUuid = protectedObj === null || protectedObj === void 0 ? void 0 : protectedObj.providerIdentity.uuid;
            const providerName = protectedObj === null || protectedObj === void 0 ? void 0 : protectedObj.providerIdentity.name;
            // eslint-disable-next-line no-console
            console.warn(`WARNING: Dispatch call may have unintended results. The "to" argument of your dispatch call is missing the
                "endpointId" parameter. The identity you are dispatching to ({uuid: ${uuid}, name: ${name}})
                has multiple channelClients for this channel. Your dispatched action: (${action}) from the provider:
                ({uuid: ${providerUuid}, name: ${providerName}}) will only be processed by the most recently-created client.`);
        }
        // Pop to return the most recently created endpointId.
        return (_a = matchingConnections.pop()) === null || _a === void 0 ? void 0 : _a.endpointId;
    }
    // eslint-disable-next-line class-methods-use-this
    static clientIdentityIncludesEndpointId(subscriptionIdentity) {
        return subscriptionIdentity.endpointId !== undefined;
    }
    // eslint-disable-next-line class-methods-use-this
    static clientIsMultiRuntime(subscriptionIdentity) {
        return subscriptionIdentity.runtimeUuid !== undefined;
    }
}
exports.ChannelProvider = ChannelProvider;
_ChannelProvider_connections = new WeakMap(), _ChannelProvider_protectedObj = new WeakMap(), _ChannelProvider_strategy = new WeakMap(), _ChannelProvider_removeEndpoint = new WeakMap(), _ChannelProvider_close = new WeakMap();
// The following line should be changed following a typescript update.
// static #removalMap = new WeakMap<ChannelProvider, Function>();
ChannelProvider.removalMap = new WeakMap();
